export namespace MGST {
	export namespace profiles {
		export interface tests {
			id: string;
			tid: number;
			title: string;
			active: boolean;
			options: options[];
			groups?: {
				id: number;
				title: string;
				tests: number[];
			}[];
			min: number;
			max: number;
			step: number;
		}

		export interface options {
			id?: number;
			text: string;
			value: number;
			// Indica si esta oculto el valor
			hidden?: boolean;
			// Texto de ayuda
			tooltip?: string;
		}
	}
	export namespace pages {
		export function isPage(s: string) {
			return s.length != 10 && s.length != 16;
		}
		export enum employees {
			E0_1 = 1,
			E2_10 = 2,
			E11_50 = 3,
			E51_200 = 4,
			E201_500 = 5,
			E501_1000 = 6,
			E1001_5000 = 7,
			E5001_10000 = 8,
			E1001 = 9
		}
		export enum sector {
			"Empresa publica" = 1,
			"Institucion educativa" = 2,
			"Organizacion gubernamental" = 3,
			"Organizacion sin ánimo de lucro" = 4,
			"Empresa individual" = 5,
			"Empresa privada" = 6,
			"Asociacion" = 7,
			"Agencia de reclutamiento" = 8,
			"Autonomo" = 9
		}
		export interface ats_config {
			id?: string;
			title_toolbar?: string;
			og_img?: string;
			descrip_short?: string;
			perm_msg?: string;
			title: string;
			slogan: string;
			logo: string;
			logo_round: string;
			favicon: string;
			app_color: string;
			primary: string;
			dark: string;
			accent: string;
		}
	}

	export namespace report {
		export enum types {
			PERSONAL_INFORMATION = 0,
			PSYCOMETRIC_DATA = 1,
			PMA = 2,
			INTEGRITY = 3,
			ASSESSMENT = 4,
			INTERVIEW = 5,
			CV = 6,
			COMPETENCIES = 7
		}
	}
	export namespace subscription {
		export enum types {
			ats = 0,
			psyco = 1,
			psyco_try = 2,
			ses = 3,
			poly = 4,
			jobboard = 5,
			headhunting = 6,
			messages = 7,
			tests = 8,
			interviews = 9,
			job_request = 10
		}

		export interface ses {
			// Service Name
			name?: string;
			providers: {
				pgid: string;
				name: string;
				emails: string[];
				logo: string;
				logo_round?: string;
				color: { app: string; primary: string };
				slack?: {
					url: string;
					channel: string;
				};
			}[];
		}
	}

	export namespace users_tmp {
		export const tmp_mark = "-tmp";
		export namespace digeduca {}
		export enum types {
			ALL = -1,
			FCM = 0,
			DIGEDUCA = 1,
			PRONACOM = 2,
			DIGEDUCA_v2 = 3,
			CAFA = 4
		}
	}

	export namespace test {
		export const adminID = "-KzZYgMqxZ4T";

		export function getTestName(t_id: bigint | number): string {
			let capitalize = (str?: string) => {
				if (!str) {
					console.log(`${t_id} no tiene nombre`);
					return t_id + "";
				}
				return str.charAt(0).toUpperCase() + str.slice(1);
			};
			switch (t_id) {
				case tid.INTEGRITYX:
					return "IntegrityX";
				case tid.INTEGRITYX_PRO:
					return "IntegrityX Pro";
			}
			return capitalize(MGST.test.tid[Number(t_id)]?.replace("_", " ").trim());
		}

		export enum type {
			NORMAL = 0,
			CLEAVER = 1,
			OTIS = 2,
			OTIS_GAMMA = 3,
			WONDERLIC = 4,
			_16PF = 5,
			TERMAN = 6,
			DOMINOS = 7,
			MOSS = 8,
			KOSTICK = 9,
			IPV = 10,
			MBTI = 11, // MYERS_BRIGGS
			ZAVIC = 12,
			LIFO = 13,
			ALLPORT = 14,
			RAVEN = 15,
			// Testing stage
			GORDON = 16,
			BFQ = 17,
			// Testing stage
			CE = 18,

			// PMA
			PMA_VERBAL = 19,
			PMA_ESPACIAL = 20,
			PMA_MECANICO = 21,
			PMA_NUMERICO = 22,
			PMA_ABSTRACTO = 23,
			PMA_VELOCIDAD = 24,
			// specific
			TYPING = 25,
			INTEGRITYX = 26,
			ENGLISH = 27,
			NEO_PIR = 28,
			// COMPETENCIES
			PPC_G = 29,
			PPC = 30,
			// INTELIGENCIA EMOCIONAL
			IE = 31,
			// LATERALIDAD CEREBRAL
			LAT_CEREBRAL = 32,

			/** Orientación Vocacional, Intereses de estudio */
			OVIE = 33,

			// SAT
			ORTOGRAFIA = 34,
			OFIMATICA = 35,
			IM = 36, // INTELIGENCIAS MULTIPLES
			ENGLISH_LEVEL = 37, // ENGLISH LEVEL TEST
			IV = 38, // INTERESES VOCACIONALES
			MARKETING = 39,
			PRIMEROS_AUXILIOS = 40,
			CONTABILIDAD_I = 41,
			CONTABILIDAD_II = 42,
			FINANZAS = 43,
			BENDER = 44,
			REMOTE_READINESS = 45,
			WORK_ENV = 46,
			INTEGRITY_PRO = 47,
			PUBLICIDAD_LINKEDIN = 48,
			SIX_SIGMA = 49,
			SALES_FORCE_BDR = 50,
			COACHING_ESTRATEGICO = 51,
			INGENIERIA_AEROESPACIAL = 52,
			GESTION_CAMBIO = 53,
			JEFE_MAQUINA = 54,
			EXPECIENCIA_USUARIO = 55,
			APTITUD_VENTAS = 56,
			SEGURIDAD_DATOS = 57,
			REALIZACION_ENTREVISTA = 58,
			TOMA_DECISIONES_DATOS = 59,
			FACTURACION_MEDIANA = 60,
			HABILIDADES_ECOMMERCE = 61,
			ARQUITECTURA_SISTEMAS = 62,
			NARRACION_DATOS = 63,
			DERECHO_CORPORATIVO_EEUU = 64,
			GESTION_PROYECTOS_CONSTRUCCION = 65,
			ETL_DATOS = 66,
			ORGANIZACION_DE_DATOS = 67,
			FUNDAMENTOS_DE_REDES = 68,
			OPTIMIZACION_CONVERSION = 69,
			MARKETING_AFILIADOS = 70,
			MANAGER_PRODUCTOS_IA = 71,
			PENSAMIENTO_DISENO = 72,
			DERECHO_LABORAL_EEUU = 73,
			CREADOR_CONTENIDO_VIDEO = 74,
			DERECHO_CONTRACTUAL_EEUU = 75,
			GESTION_INGENIERIA_SOFTWARE = 76,
			FORMACION_DESARROLLO = 77,
			COORDINACION_TURNOS = 78,
			INGENIERIA_ESTRUCTURAL = 79,
			DERECHO_PENAL_EEUU = 80,
			MARKETING_TIKTOK = 81,
			DIFUSION_SEO = 82,
			RELACIONES_PUBLICAS = 83,
			FARMACEUTICO = 84,
			TECNICOS_FARMACEUTICOS = 85,
			DERECHO_MERCANTIL_INTERNACIONAL = 86,
			HIPAA = 87,
			AUDITORIA_INTERNA = 88,
			PROPIEDAD_INTELECTUAL = 89,
			RECEPCIONISTA = 90,
			COMUNIDADES_REDES_SOCIALES = 91,
			MODELADO_DATOS = 92,
			MICROSOFT_DYNAMICS_365 = 93,
			INVESTIGACION_REDACCION_LEGAL = 94,
			ANALISIS_MARKETING = 95,
			PROCESAMIENTO_LENGUAJE_NATURAL = 96,
			FUNDAMENTOS_CADENA_SUMINISTRO = 97,
			APRENDIZAJE_REFUERZO = 98,
			GESTION_RESTAURANTES = 99,
			NORMAS_INTERNACIONALES_AUDITORIA = 100,
			GESTION_VENTAS = 101,
			TELEMEDICINA = 102,
			ASISTENTE_LEGAL_EEUU = 103,
			ANALISIS_COMERCIO_ELECTRONICO = 104,
			MICROSOFT_INTUNE = 105,
			GESTION_PROGRAMAS = 106,
			DILIGENCIA_DEBIDA_FINANCIERA = 107,
			PLANIFICADOR_MERCANCIA = 108,
			VENTAS_MINORISTAS = 109,
			RESPONSABLE_COMPRAS = 110,
			MARKETING_MOVIL = 111,
			GESTION_RRHH = 112,
			GESTION_FINANCIERA = 113,
			PUBLICIDAD_META = 114,
			GESTION_PRODUCTOS = 115,
			QUICKBOOKS_ONLINE = 116,
			GESTION_PATRIMONIAL = 117,
			APRENDIZAJE_AUTOMATICO = 118,
			CALCULO_COSTOS = 119,
			APRENDIZAJE_PROFUNDO = 120,
			FINANZAS_DESCENTRALIZADAS = 121,
			GENERACION_CLIENTES_POTENCIALES = 122,
			ASISTENTE_EJECUTIVO = 123,
			DESARROLLO_BASES_DATOS = 124,
			CIENCIA_DATOS = 125,
			ESTRATEGIA_MARCA = 126,
			GESTION_BASES_DATOS = 127,
			GESTION_OPERACIONES = 128,
			DESARROLLO_BLOCKCHAIN = 129,
			REPRESENTANTE_ATENCION_TELEFONICA = 130,
			INTELIGENCIA_ARTIFICIAL = 131,
			ASISTENTE_ADMINISTRATIVO = 132,
			ALGORITMOS_INGENIERIA_SOFTWARE = 133,
			CONTABILIDAD_INTERMEDIO = 134,
			EJECUTIVOS_CUENTAS = 135,
			CONTABILIDAD_AVANZADA_NIIF = 136,
			PRUEBAS_PENETRACION = 137,
			TELEVENTA_B2C = 138,
			MATEMATICAS_FINANCIERAS = 139,
			ESTADISTICA_PROBABILIDAD = 140,
			ANALISIS_MERCADO = 141,
			ESTUDIOS_MERCADO = 142,
			TECNICAS_CULINARIAS = 143,
			MANTENIMIENTO_EQUIPOS = 144,
			HVAC = 145,
			TERMINOLOGIA_CONTABLE = 146,
			COORDINADOR_TRANSPORTE = 147,
			CONOCIMIENTO_INFORMATICA_MAC = 148,
			MARKETING_CRECIMIENTO = 149,
			ELABORACION_PRESUPUESTO = 150,
			ANALISIS_EXPLORATORIO_DATOS = 151,
			MAQUINISTA_CNC = 152,
			REPRESENTANTE_ASISTENCIA_TECNICA = 153,
			ESTRATEGIA_CONTENIDO = 154,
			EJECUTIVO_COMPRAS_INTERNACIONALES = 155,
			EJECUTIVO_COMPRAS_LOCALES = 156,
			CONOCIMIENTO_INFORMATICA_PC = 157,
			GD_T = 158,
			FUNDAMENTOS_ELECTRICIDAD = 159,
			SUPERVISOR_ALMACEN = 160,
			PROPIETARIO_PRODUCTO = 161,
			CONTABILIDAD_FINANCIERA_GAAP = 162,
			EVALUAR_RECOLECCION_PEDIDOS = 163,
			CONTABILIDAD_FINANCIERA_NIIF = 164,
			SCRUM_MASTER = 165,
			INGENIERIA_SOFTWARE = 166,
			CUENTAS_COBRAR = 167,
			CUENTAS_PAGAR = 168,
			GESTION_PROYECTOS = 169,
			HOSTELERIA = 170,
			REPRESENTANTE_EXITO_CLIENTE = 171,
			ADOBE_PHOTOSHOP = 172,
			ANALISTA_NEGOCIOS_TI = 173,
			FUNDAMENTOS_RRHH = 174,
			RGPD_PRIVACIDAD = 175,
			CONTABILIDAD_AVANZADA_GAAP = 176,
			SERVICIO_ATENCION_CLIENTE = 177,
			ADOBE_ILLUSTRATOR = 178,
			WORDPRESS = 179,
			EMAIL_MARKETING = 180,
			GOOGLE_ANALYTICS = 181,
			REDACCION_SEO = 182,
			AWS = 183,
			MICROSOFT_EXCEL = 184,
			ARQUITECTO_SOFTWARE = 185,
			ANALISIS_DATOS = 186,
			PUBLICIDAD_PPC = 187,
			SALESFORCE_CRM = 188,
			MODELOS_FINANCIEROS_EXCEL = 189,
			DISENO_UX_UI = 190,
			CIBERSEGURIDAD = 191,
			VENTAS_EXTERNAS_B2B = 192,
			ADMINISTRACION_SISTEMAS_NUBE = 193,
			RECLUTAMIENTO_TALENTO = 194,
			ZENDESK = 195,
			HUBSPOT_CRM = 196,
			INGENIERO_CONTROL_CALIDAD = 197,
			SEO_TECNICO = 198,
			GOOGLE_ADS = 199,
			GESTION_REDES_SOCIALES = 200,
			DEVOPS = 201,
			GESTION_MARCA = 202,
			GESTION_MARKETING_PRODUCTOS = 203,
			PMA = 204
		}

		export enum tid {
			CLEAVER = 1,
			OTIS = 2,
			OTIS_GAMMA = 3,
			WONDERLIC = 4,
			_16PF = 5,
			TERMAN = 6,
			DOMINOS = 7,
			MOSS = 8,
			KOSTICK = 9,
			IPV = 10,
			MBTI = 11, // MYERS_BRIGGS
			ZAVIC = 12,
			LIFO = 13,
			ALLPORT = 14,
			RAVEN = 15,
			// Testing stage
			GORDON = 16,
			BFQ = 17,
			CE = 18,

			// PMA
			PMA_VERBAL = 19,
			PMA_ESPACIAL = 20,
			PMA_MECANICO = 21,
			PMA_NUMERICO = 22,
			PMA_ABSTRACTO = 23,
			PMA_VELOCIDAD = 24,
			// specific
			TYPING = 25,
			TYPING_ES = 1810465,
			INTEGRITYX = 26,
			ENGLISH = 27,
			NEO_PIR = 28,
			// COMPETENCIES
			PPC_G = 29,
			PPC = 30,
			// INTELIGENCIA EMOCIONAL
			INTELIGENCIA_EMOCIONAL = 31,
			// LATERALIDAD CEREBRAL
			LATERALIDAD_CEREBRAL = 32,

			/** Orientación Vocacional, Intereses de estudio */
			OVIE = 33,

			// SAT
			ORTOGRAFIA = 34,
			OFIMATICA = 35,
			INTELIGENCIAS_MULTIPLES = 36, // INTELIGENCIAS MULTIPLES
			ENGLISH_LEVEL = 37,
			INTERESES_VOCACIONALES = 38, // INTERESES VOCACIONALES
			MARKETING = 39,
			PRIMEROS_AUXILIOS = 40,
			CONTABILIDAD_I = 41,
			CONTABILIDAD_II = 42,
			FINANZAS = 43,
			BENDER = 44,
			REMOTE_READINESS = 45,
			WORK_ENV = 46,
			INTEGRITYX_PRO = 47,

			// Generic tests

			PUBLICIDAD_LINKEDIN = 48,
			SIX_SIGMA = 49,
			SALES_FORCE_BDR = 50,
			COACHING_ESTRATEGICO = 51,
			INGENIERIA_AEROESPACIAL = 52,
			GESTION_CAMBIO = 53,
			JEFE_MAQUINA = 54,
			EXPECIENCIA_USUARIO = 55,
			APTITUD_VENTAS = 56,
			SEGURIDAD_DATOS = 57,
			REALIZACION_ENTREVISTA = 58,
			TOMA_DECISIONES_DATOS = 59,
			FACTURACION_MEDIANA = 60,
			HABILIDADES_ECOMMERCE = 61,
			ARQUITECTURA_SISTEMAS = 62,
			NARRACION_DATOS = 63,
			DERECHO_CORPORATIVO_EEUU = 64,
			GESTION_PROYECTOS_CONSTRUCCION = 65,
			ETL_DATOS = 66,
			ORGANIZACION_DE_DATOS = 67,
			FUNDAMENTOS_DE_REDES = 68,
			OPTIMIZACION_CONVERSION = 69,
			MARKETING_AFILIADOS = 70,
			MANAGER_PRODUCTOS_IA = 71,
			PENSAMIENTO_DISENO = 72,
			DERECHO_LABORAL_EEUU = 73,
			CREADOR_CONTENIDO_VIDEO = 74,
			DERECHO_CONTRACTUAL_EEUU = 75,
			GESTION_INGENIERIA_SOFTWARE = 76,
			FORMACION_DESARROLLO = 77,
			COORDINACION_TURNOS = 78,
			INGENIERIA_ESTRUCTURAL = 79,
			DERECHO_PENAL_EEUU = 80,
			MARKETING_TIKTOK = 81,
			DIFUSION_SEO = 82,
			RELACIONES_PUBLICAS = 83,
			FARMACEUTICO = 84,
			TECNICOS_FARMACEUTICOS = 85,
			DERECHO_MERCANTIL_INTERNACIONAL = 86,
			HIPAA = 87,
			AUDITORIA_INTERNA = 88,
			PROPIEDAD_INTELECTUAL = 89,
			RECEPCIONISTA = 90,
			COMUNIDADES_REDES_SOCIALES = 91,
			MODELADO_DATOS = 92,
			MICROSOFT_DYNAMICS_365 = 93,
			INVESTIGACION_REDACCION_LEGAL = 94,
			ANALISIS_MARKETING = 95,
			PROCESAMIENTO_LENGUAJE_NATURAL = 96,
			FUNDAMENTOS_CADENA_SUMINISTRO = 97,
			APRENDIZAJE_REFUERZO = 98,
			GESTION_RESTAURANTES = 99,
			NORMAS_INTERNACIONALES_AUDITORIA = 100,
			GESTION_VENTAS = 101,
			TELEMEDICINA = 102,
			ASISTENTE_LEGAL_EEUU = 103,
			ANALISIS_COMERCIO_ELECTRONICO = 104,
			MICROSOFT_INTUNE = 105,
			GESTION_PROGRAMAS = 106,
			DILIGENCIA_DEBIDA_FINANCIERA = 107,
			PLANIFICADOR_MERCANCIA = 108,
			VENTAS_MINORISTAS = 109,
			RESPONSABLE_COMPRAS = 110,
			MARKETING_MOVIL = 111,
			GESTION_RRHH = 112,
			GESTION_FINANCIERA = 113,
			PUBLICIDAD_META = 114,
			GESTION_PRODUCTOS = 115,
			QUICKBOOKS_ONLINE = 116,
			GESTION_PATRIMONIAL = 117,
			APRENDIZAJE_AUTOMATICO = 118,
			CALCULO_COSTOS = 119,
			APRENDIZAJE_PROFUNDO = 120,
			FINANZAS_DESCENTRALIZADAS = 121,
			GENERACION_CLIENTES_POTENCIALES = 122,
			ASISTENTE_EJECUTIVO = 123,
			DESARROLLO_BASES_DATOS = 124,
			CIENCIA_DATOS = 125,
			ESTRATEGIA_MARCA = 126,
			GESTION_BASES_DATOS = 127,
			GESTION_OPERACIONES = 128,
			DESARROLLO_BLOCKCHAIN = 129,
			REPRESENTANTE_ATENCION_TELEFONICA = 130,
			INTELIGENCIA_ARTIFICIAL = 131,
			ASISTENTE_ADMINISTRATIVO = 132,
			ALGORITMOS_INGENIERIA_SOFTWARE = 133,
			CONTABILIDAD_INTERMEDIO = 134,
			EJECUTIVOS_CUENTAS = 135,
			CONTABILIDAD_AVANZADA_NIIF = 136,
			PRUEBAS_PENETRACION = 137,
			TELEVENTA_B2C = 138,
			MATEMATICAS_FINANCIERAS = 139,
			ESTADISTICA_PROBABILIDAD = 140,
			ANALISIS_MERCADO = 141,
			ESTUDIOS_MERCADO = 142,
			TECNICAS_CULINARIAS = 143,
			MANTENIMIENTO_EQUIPOS = 144,
			HVAC = 145,
			TERMINOLOGIA_CONTABLE = 146,
			COORDINADOR_TRANSPORTE = 147,
			CONOCIMIENTO_INFORMATICA_MAC = 148,
			MARKETING_CRECIMIENTO = 149,
			ELABORACION_PRESUPUESTO = 150,
			ANALISIS_EXPLORATORIO_DATOS = 151,
			MAQUINISTA_CNC = 152,
			REPRESENTANTE_ASISTENCIA_TECNICA = 153,
			ESTRATEGIA_CONTENIDO = 154,
			EJECUTIVO_COMPRAS_INTERNACIONALES = 155,
			EJECUTIVO_COMPRAS_LOCALES = 156,
			CONOCIMIENTO_INFORMATICA_PC = 157,
			GD_T = 158,
			FUNDAMENTOS_ELECTRICIDAD = 159,
			SUPERVISOR_ALMACEN = 160,
			PROPIETARIO_PRODUCTO = 161,
			CONTABILIDAD_FINANCIERA_GAAP = 162,
			EVALUAR_RECOLECCION_PEDIDOS = 163,
			CONTABILIDAD_FINANCIERA_NIIF = 164,
			SCRUM_MASTER = 165,
			INGENIERIA_SOFTWARE = 166,
			CUENTAS_COBRAR = 167,
			CUENTAS_PAGAR = 168,
			GESTION_PROYECTOS = 169,
			HOSTELERIA = 170,
			REPRESENTANTE_EXITO_CLIENTE = 171,
			ADOBE_PHOTOSHOP = 172,
			ANALISTA_NEGOCIOS_TI = 173,
			FUNDAMENTOS_RRHH = 174,
			RGPD_PRIVACIDAD = 175,
			CONTABILIDAD_AVANZADA_GAAP = 176,
			SERVICIO_ATENCION_CLIENTE = 177,
			ADOBE_ILLUSTRATOR = 178,
			WORDPRESS = 179,
			EMAIL_MARKETING = 180,
			GOOGLE_ANALYTICS = 181,
			REDACCION_SEO = 182,
			AWS = 183,
			MICROSOFT_EXCEL = 184,
			ARQUITECTO_SOFTWARE = 185,
			ANALISIS_DATOS = 186,
			PUBLICIDAD_PPC = 187,
			SALESFORCE_CRM = 188,
			MODELOS_FINANCIEROS_EXCEL = 189,
			DISENO_UX_UI = 190,
			CIBERSEGURIDAD = 191,
			VENTAS_EXTERNAS_B2B = 192,
			ADMINISTRACION_SISTEMAS_NUBE = 193,
			RECLUTAMIENTO_TALENTO = 194,
			ZENDESK = 195,
			HUBSPOT_CRM = 196,
			INGENIERO_CONTROL_CALIDAD = 197,
			SEO_TECNICO = 198,
			GOOGLE_ADS = 199,
			GESTION_REDES_SOCIALES = 200,
			DEVOPS = 201,
			GESTION_MARCA = 202,
			GESTION_MARKETING_PRODUCTOS = 203,
			PMA = 204
		}
		/** Esto es para llevar el control de que pruebas psico se puede descargar en excel (estoy hay que ir programandolo una en una) */
		export const psycho_can_download = [
			MGST.test.type.ZAVIC,
			MGST.test.type.CLEAVER,
			MGST.test.type.TERMAN,
			MGST.test.type.IPV,
			MGST.test.type._16PF,
			MGST.test.type.PPC_G,
			MGST.test.type.INTEGRITYX
		];

		/** Esto se usa para hacer un autoassign y buscar el ownerID */
		export class SpecialTestID {
			static has(tid: number) {
				return tid < 1000;
			}
		}

		export enum preferences {
			SHOW_REALTIME_RESULTS = 1,
			FEEDBACK_RESULTS = 2,
			RANDOM_QUESTIONS = 3,
			WEBCAM_REQUIRED = 4,
			ONLY_DESKTOP = 5,
			SHARE_SCREEN_REQUIRED = 6,
			DPI_PHOTO = 7,
			NO_PERSONAL_INFO = 8,
			SKIP_QUESTIONS = 9,
			ENHANCED_MONITORING = 10,
			MONITOR = 11,
			HEADSHOT_REQUIRED = 12,
			HIDE_COMPANY = 13,
			ONLY_APP = 14,
			RECORD_SCREEN = 15,
			RECORD_CAM = 16
		}

		export namespace cameras {
			export enum n {
				"facetime" = "facetime",
				"front" = "front",
				"web" = "web",
				"integrated" = "integrated",
				"truevision" = "truevision",
				"hp wide" = "hp wide",
				"hd camera" = "hd camera",
				"hc camera" = "hc camera",
				"facecam" = "facecam",
				"logitec" = "logitec"
			}
		}

		export namespace groups {
			export namespace questions {
				export enum types {
					SELECCION_MULTIPLE = 1,
					SELECCION_UNICA = 2,
					ELECCION_IMG = 3,
					ELECCION_IMG_MULTI = 4,
					RESP_CORTA = 6,
					RESP_LARGA = 7,
					ESCALA_OPINION = 8,
					ARCHIVO = 9,
					VOZ = 10,
					SI_NO = 11,
					FECHA = 12,
					RESPUESTA_EXACTA = 13,
					RESPUESTAS_EXACTAS = 14,
					MAS_MENOS = 15,
					TEL = 16,
					/** Se usa en Zavic y en Allport */
					COMPLETE_INPUT = 17,
					ELECCION_AUDIO = 18,
					TYPING = 19,
					MULTI_YES_NO = 20,
					COMPLETE_INPUT_V2 = 21,
					VIDEO = 22,
					/** Es una respuesta de selección unica pero con un ct-select */
					UNIQUE_SELECTION_LARGE = 24
				}
			}
		}
		export type rules = {
			can_repeat?: boolean;
			/** Cuando es con checkbox */
			max_correct?: number;
			answer?: {
				type: "number" | "text" | "string";
				style?: "upper" | "lower" | "capitalize";
				/** Solo aplica cuando es type:number */
				min?: number;
				/** Solo aplica cuando es type:number */
				max?: number;
				/** Solo aplica cuando es type:number */
				sum?: number;
				/** Es el tooltip que se le pone a cada opcion de respuesta */
				title?: string;
			};
			/** Es el tipo de archivo que se acepta para las preguntas de tipo ARCHIVO = 9 */
			accept?: string;
		};
	}

	export namespace tests_complete {
		export type score_t17 = {
			pts: number;
			pts_pos: number[];
			pts_neg: number[];
		};
		export type score_t1000 = {
			wpm: number;
			os: string;
			correct: number;
			incorrect: number;
			keystrokes: number;
		};
		export type schedule = {
			s: number;
			f: number;
		};
		export type cameras = {
			/** Nombre de la camara */
			n: string;
			/** Si fue esta la que uso */
			u: boolean;
		};
		export type header = {
			// Puesto | Empresa | Reclutador | Email | Edad | Genero | DPI
			/** Position */
			post?: string | null;
			/** Company name */
			company?: string | null;
			/** Recliuter name */
			recruiter?: string | null;
			/** Candidate Email */
			email?: string | null;
			/** Computed Candidate Age. Ej: 27 */
			age?: string | null;
			/** Gender */
			gender?: boolean | null;
			/** CUI */
			dpi?: string | null;
			/** Candidate name */
			name?: string | null;
		};
		export enum complete_msg {
			foul = "foul",
			foul_by_monitor = "foul_by_monitor",
			onblur = "onblur",
			already_complete = "202",
			ok = "ok",
			doing = "doing",
			allok = "allok",
			timeout = "timeout",
			timeover = "timeout2",
			qualifying = "qualifying"
		}
	}

	export namespace automation {
		export interface t0 {
			test: {
				t_id?: string;
				tid?: number;
				gtlt?: number;
				target: number;
				/** Test Type */
				type?: MGST.test.type;
				note?: number;
			}[];
			position_id?: string;
			moveto: number;
			notify_to?: { uid?: string; email?: string }[];
			message?: { message?: string; send?: boolean };
			module: "jobs" | "headhunting" | "jobboard" | "internship";
			jid: number;
		}
	}

	export namespace poly {
		export enum phases {
			MEETING = "meeting",
			COMPLETED = "completed",
			REPORT = "report"
		}
	}

	export namespace ses {
		export interface SesClass {
			complete?: Complete[];
			personal: Personal;
			laboral: Laboral[];
			social: Social[];
			referrer: Referrer;
			family_structure: FamilyStructure;
			economics: Economics;
			housing: Housing;
			annexes?: { name: string; url: string }[];
		}

		export type Complete = "personal" | "laboral" | "social" | "referrer" | "family_structure" | "economics" | "housing" | "opinion";

		export interface Housing {
			home?: { name: string; url: string }[];
			candidate?: { name: string; url: string }[];
			location?: { home: string; photo: string; photo_zoomed: string };
		}

		export interface Economics {
			ingress: Ingress[];
			egress: Egress[];
			living_place: LivingPlace;
			neighborhood: Neighborhood;
			vehicules: Vehicule[];
			bank_commercial_references: BankCommercialReferences;
		}

		export interface BankCommercialReferences {
			accounts: Account[];
			cards: Card[];
		}

		export interface Account {
			bank: string;
			account_type: number;
			amount: number;
			currency: string;
		}

		export interface Card {
			card_type: number;
			bank: string;
			amount: number;
			currency: string;
			credit_limit: number;
			stauts: string;
			time_slow_payer: number;
		}

		export interface Egress {
			type?: number;
			amount?: number;
			contribution?: number;
			currency?: string;
			other?: Other[];
		}

		export interface Other {
			name?: string;
			contribution?: number;
		}

		export interface Ingress {
			type?: number;
			concept?: string;
			salary?: number;
			other_concept?: string;
			other_ingress?: number;
			currency?: string;
		}

		export interface LivingPlace {
			time_to_reside?: number;
			num_people_in_home?: number;
			change_home?: boolean;
			time_to_reside_last?: number;
			reason_to_change?: string;
			home_type?: number;
			rent_cost?: number;
			rent_currency?: string;
			levels?: number;
			style?: string;
			material?: string;
			furniture?: string;
			floor?: string;
			services?: string;
			comparition_neighboring_homes?: string;
			home_external_condition?: string;
			home_internal_condition?: string;
		}

		export interface Neighborhood {
			social_lvl?: string;
			public_transp?: string;
			police_zone_type?: string;
		}

		export interface Vehicule {
			brand?: string;
			model?: string;
			plate?: string;
			value?: number;
			currency?: string;
		}

		export interface FamilyStructure {
			father: FamilyMember;
			mother: FamilyMember;
			brothers: FamilyMember[];
			mate: FamilyMember[];
			sons: FamilyMember[];
			observations: string;
		}

		export interface FamilyMember {
			name?: string;
			birthday?: number;
			civil_status?: number;
			studies?: number;
			profession?: string;
			where_works?: string;
			sindicato?: string;
			has_been_jail?: boolean;
			salary?: number;
			currency?: string;
			lives_same_house?: boolean;
			how_is_relationship?: string;
		}

		export interface Laboral {
			_id: number;
			co_name: string;
			title: string;
			referrer_request: number;
			init_time: number;
			finish_time: number;
			salary: number;
			currency: string;
			last_salary: number;
			last_currency: string;
			reason_departure: string;
			considered_rehire: boolean;
			informant_name: string;
			informant_position: string;
			observations: string;
			boss_name: string;
			boss_position: string;
			boss_number: string;
			puntuality: number;
			personal_presentation: number;
			conduct: number;
			relationship_superiors: number;
			teamwork: number;
			regulatory_compliance: number;
			performance: number;
			Qualities: string;

			iniciativa: number;
			responsabilidad: number;
			organization: number;
			creativity: number;
			honradez: number;
			honestidad: number;
			autocontrol: number;

			areas_opportunity: string;
			work_pressure: string;
			decision_making: string;
			leadership: string;
			proactivity: string;
			work_without_supervision: string;
			how_many_people_under_your_charge: string;
			it_has_belonged_to_a_union_group: string;
			he_has_sued_the_company: string;
			vices: string;
		}

		export interface Personal {
			general_info: GeneralInfo;
			docs: Docs;
			school: School;
			state_physical_health: IStatePhysicalHealth;
			habits: Habits;
			body_marks: BodyMarks;
			eval_personalidad: EvalPersonalidad;
			eval_labor: EvalLabor;
			aficiones: Aficiones;
		}

		// Generated by https://quicktype.io

		export interface IStatePhysicalHealth {
			height?: number;
			weight?: number;
			tez_color?: string;
			particular_signs?: string;
			eye_color?: string;
			physical_completion?: string;
			chronic_diseases?: string;
			Surgeries?: string;
			Accidents?: string;
			Allergies?: string;
			take_medication?: string;
			special_capac?: string;
			go_to_hostpital_frec?: string;
			when_go_hostpital?: number;
			been_admitted_to_a_hospital?: string;
			some_member_is_missing?: string;
			vision_defect?: string;
			listen_defect?: string;
		}

		export interface Aficiones {
			//section_name: string;
			data: AficionesData;
		}

		export interface AficionesData {
			read?: boolean;
			read_frec?: string;
			movies?: boolean;
			movies_frec?: string;
			music?: boolean;
			music_frec?: string;
			tv?: boolean;
			tv_frec?: string;
			sport?: boolean;
			sport_frec?: string;
			other?: string;
			other_frec?: string;
		}

		export interface BodyMarks {
			//section_name: string;
			data: BodyMarksData;
		}

		export interface BodyMarksData {
			tatto?: boolean;
			tatto_place?: string;
			tatto_measure?: number;
			tatto_meaning?: string;
			earrings?: boolean;
			earrings_place?: string;
			earrings_meaning?: string;
			tallados?: boolean;
			tallados_place?: string;
			tallados_meaning?: string;
		}

		export interface Docs {
			//section_name: string;
			data: DocsData;
		}

		export interface DocsData {
			dpi?: string;
			dpi_extended?: number;
			social_num?: string;
			social_num_verified?: boolean;
			irtra_num?: string;
			driver_lic?: boolean;
			driver_lic_type?: string;
			driver_lic_valid?: number;
			passport?: string;
			passport_valid?: number;
			usa_visa?: string;
			usa_visa_valid?: number;
			nit?: string;
			criminal_record?: string;
			criminal_record_valid?: number;
			criminal_record_verified?: string;
			police_record?: string;
			police_record_valid?: number;
			police_record_verified?: string;
			healt_card?: string;
			healt_card_valid?: number;
			healt_card_verified?: string;
			lungs_card?: string;
			lungs_card_valid?: number;
			lungs_card_verified?: string;
			food_handling?: string;
			food_handling_valid?: number;
			food_handling_verified?: string;
		}

		export interface EvalLabor {
			//section_name: string;
			data: EvalLaborData;
		}

		export interface EvalLaborData {
			stable_job?: boolean;
			describe_worker?: string;
			is_absent_work?: boolean;
			boring_rep_tasks?: boolean;
			how_react_cretics?: string;
			react_objection_ideas?: string;
			offered_bribe?: string;
			counterfeit_work_doc?: string;
			accused_of_theft?: string;
			partic_sindicato?: string;
			opinion_sindicato?: string;
			obj_professional?: string;
			short_term?: string;
			mid_term?: string;
			long_term?: string;
			business_expectation?: string;
		}

		export interface EvalPersonalidad {
			//section_name: string;
			data: EvalPersonalidadData;
		}

		export interface EvalPersonalidadData {
			describe?: string;
			smart_people?: boolean;
			angry_reaction?: string;
			dislike_people?: string;
			what_are_your_values?: string;
			how_face_dislike_tast?: string;
			falsify_doc?: boolean;
			falsify_doc_explain?: string;
			personal_objectives?: string;
			short_term?: string;
			mid_term?: string;
			long_term?: string;
			have_guns?: boolean;
			have_guns_explain?: string;
			has_been_jail?: boolean;
			has_been_jail_explain?: string;
		}

		export interface GeneralInfo {
			//section_name: string;
			data: GeneralInfoData;
		}

		export interface GeneralInfoData {
			name?: string;
			last_name?: string;
			place_born?: number;
			birthday?: number;
			nationality?: number;
			state?: number;
			city?: number;
			nationality_other?: number[];
			civil_status?: number;
			tel?: string[];
			cel?: string[];
			email?: string;
			langs?: Lang[];
			ethnicity?: number;
			blood_type?: string;
			dir?: string;
			profession_area?: number[];
			profession_rubro?: number[];
			collegiate_number?: string;
			religion?: string;
		}

		export interface Lang {
			lang: number;
			lvl: number;
		}

		export interface Habits {
			// section_name: string;
			data: HabitsData;
		}

		export interface HabitsData {
			tobacco?: boolean;
			tobacco_quantity?: string;
			tobacco_frecuency?: string;
			alcohol?: boolean;
			alcohol_quantity?: string;
			alcohol_frecuency?: string;
			drugs?: boolean;
			type?: string[];
			drugs_quantity?: string;
			drugs_frecuency?: string;
			observations?: string;
		}

		export interface School {
			// section_name: string;
			data: SchoolData[];
		}

		export interface SchoolData {
			init_time: number;
			finish_time: number;
			co_name: string;
			career: string;
			areas: string[];
			rubros: string[];
			comprobante: string;
			verified: boolean;
		}

		export interface Referrer {
			personal: Family[];
			neighbors: Family[];
			family: Family[];
			others?: { title: string; text: string }[];
		}

		export interface Family {
			name: string;
			phone: string;
			relationship: string;
			address: string;
			time_to_meet: string;
			positive_aspects: string;
			negative_aspects: string;
			virtues: string;
			success_improvement: string;
			candidate_correct: string;
			why_should_hire: string;
			observations: string;
		}

		export interface Social {
			title: string;
			profile: string[];
			posts: string[];
			observations: string;
		}
	}
	export namespace SNS {
		export interface Mail {
			timestamp: Date | string;
			messageId: string;
			source: string;
			sourceArn?: string;
			sourceIp?: string;
			/** The AWS account ID of the account that was used to send the email. In the case of sending authorization, the sendingAccountId is the delegate sender's account ID. */
			sendingAccountId: string;
			destination: string[];
			headersTruncated?: boolean;
			headers?: {
				name: string;
				value: string;
			}[];
			commonHeaders?: {
				from: string[];
				date: string;
				to: string[];
				messageId: string;
				subject: string;
			};
		}

		export interface Complaint {
			feedbackId: string;
			complaintSubType: null;
			complainedRecipients: {
				emailAddress: string;
			}[];
			timestamp: string;
			userAgent: string;
			complaintFeedbackType: string;
			arrivalDate: string;
		}

		export interface Bounce {
			feedbackId: string;
			bounceType: "Transient" | "Permanent";
			bounceSubType: "General" | "MailboxFull" | "MessageTooLarge" | "ContentRejected" | "AttachmentRejected";
			bouncedRecipients: {
				emailAddress: string;
				action: string;
				status: string;
				diagnosticCode: string;
				timestamp?: string;
				feedbackId?: string;
				remoteMtaIp?: string;
				reportingMTA?: string;
			}[];
			timestamp: string;
			remoteMtaIp: string;
			reportingMTA?: string;
		}

		export interface Delivery {
			timestamp: string;
			processingTimeMillis: number;
			recipients: string[];
			smtpResponse: string;
			remoteMtaIp: string;
			reportingMTA: string;
		}
		export interface Open {
			timestamp: string | Date;
			userAgent: string;
			ipAddress: string;
		}
		export interface Click {
			timestamp: Date;
			ipAddress: string;
			userAgent: string;
			link: string;
			linkTags: null;
		}
	}

	export namespace eep_redactores {
		export enum status {
			PENDIENTE = "PENDIENTE",
			REVISION = "REVISION",
			CORRECCION = "CORRECCION",
			ACEPTADO = "ACEPTADO"
		}
		export enum tipo {
			CG = 1,
			CE = 2
		}
	}

	export namespace logs {
		export enum type {
			error = "error",
			deltest = "deltest",
			deltestcomplete = "deltestcomplete",
			assigntest = "assigntest",
			deljob = "deljob",
			delfolder = "delfolder",
			webhook_test = "webhook_test"
		}
		export interface webhook_test {
			url: string;
			uid?: string;
			_id: string;
			tid: number;
			txt: string;
			status: number;
			abort: boolean;
			manual: boolean;
			d: Date;
		}
		export interface deltest {
			by: string;
			uid?: string;
			tid: number;
			test?: any;
		}
		export interface delfolder {
			by: string;
			fid: number;
		}
		export interface deljob {
			by: string;
			jid: number;
		}
	}
}

// @ts-ignore
window.MGST = MGST;
